import Vue from 'vue'
import Vuex from 'vuex'
import ModalBuy from '@/store/modules/buy-modal'
import Auth from '@/store/modules/auth'
import Soundclip from '@/store/modules/soundclip'
import Software from '@/store/modules/software'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ModalBuy, Auth, Soundclip, Software
  },
  strict: true
})



// WEBPACK FOOTER //
// ./src/store/index.js